import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useIdleTimer } from "react-idle-timer";
import { Cubby } from "../stores/Cubby";

const IdleTimer = observer(({ cubby }: { cubby: Cubby }) => {
  const [state, setState] = useState<string>("Active");
  const [count, setCount] = useState<number>(0);
  const [remaining, setRemaining] = useState<number>(0);

  // Handler for when the user becomes idle
  const onIdle = () => {
    setState("Idle");
    cubby.setUserHasGoneIdle(true); // Triggering the Cubby store action after 30 seconds of idle time
  };

  // Handler for when the user becomes active again
  const onActive = () => {
    setState("Active");
    cubby.setUserHasGoneIdle(false); // Reset when the user becomes active
  };

  // Handler for each user action (e.g., clicks, keypresses)
  const onAction = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 1_800_000,
    //timeout: 5_000,
    throttle: 500, // Throttle updates to every 500 ms
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(getRemainingTime());
    }, 30_000);

    return () => clearInterval(interval);
  }, [getRemainingTime]);

  return (
    <>
      {/* <div>Status: {state}</div>
      <div>Action Count: {count}</div>
      <div>Remaining Time: {remaining}ms</div> */}
    </>
  );
});

export default IdleTimer;
